export default __webpack_public_path__ + "static/media/become-ac.9f8ec2c4.jpg";